/* eslint-disable camelcase */
export default {
  SET_BASIC_LOGO_INFO (state, response) {
    response.ratios = response.ratios.filter((item) => {
      if (item.id === '3') {
        return false
      }
      return true
    })
    state.basicLogoInfo = response
  },
  SET_LOGO_LIST (state, response) {
    state.logoList = response.list
    state.logoTotalCount = Number(response.total)
    state.imgList = response.list.map(item => {
      return item.path
    })
  },
  SET_OSS_INFO (state, info) {
    state.ossInfo = info
  },
  SET_UPLOAD_STATE (state, msg) {
    state.uploadState = msg
  },
  SET_LOGO_IMG (state, url) {
    state.ossUrl = url
  },
  CLEAR_LOGO_IMG (state) {
    state.ossUrl = ''
  },
  SET_SAVE_LOGO_STATE (state, msg) {
    state.saveState = msg
  },
  CLEAR_SAVE_LOGO_STATE (state) {
    state.saveState = ''
  },
  SET_LOGO_INFO (state, info) {
    let { grade_ids, name, path, ratio, school_ids, width, x_axes, y_axes, height } = info
    let formatInfo = {}
    formatInfo.checkedSchools = school_ids.split(',')
    formatInfo.checkedGrades = grade_ids.split(',')
    formatInfo.name = name
    formatInfo.ratio = ratio
    formatInfo.xAxes = x_axes
    formatInfo.yAxes = y_axes
    let type = path.split('.')[path.split('.').length - 1]
    let pic = {path,width,height,type}
    formatInfo.pic = pic
    state.logoInfo = formatInfo
  },
  SET_CHANGE_LOGO_STATE (state, param) {
    state.handleFreezeState = param
  }
}



// WEBPACK FOOTER //
// ./src/store/logo/mutations.js